module.exports = __webpack_public_path__ + "img/telfono.aa8184ef.svg";